export class ProgramFunding {
    public id: number;
    public teenReach: boolean;
    public cclc: boolean;
    public childCareAssistanceProgram: boolean;
    public parentPay: boolean;
    public communityMunicipalGrants: boolean;
    public stateParkDistrictFunding: boolean;
    public state4HFunding: boolean;
    public other: boolean;
    public otherFunding: string;
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/program/program-funding.ts